/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { SectionTitle } from 'components';
import Button from 'components/Button/Button';
import I18n from 'i18n-js';
import styles from './comunities-solicitudes-pendiente-list-page-new-onboarding-detalle.module.scss';

function isImage(url: any) {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
}
function downloadElement(value: string | undefined, type: string) {
  if (value) {
    const url = value;
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = `download.${type}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}

export const renderDocumentViewer = (
  documentos: { id: string; documento: string; nombre: string; tipo: string }[],
  title: string,
  onPreview: (src: string, index: number) => void,
  selectedSrc?: string,
  indiceSeleccionado?: number,
): JSX.Element => {
  const docSeleccionado = selectedSrc ?? documentos[indiceSeleccionado ?? 0]?.documento;

  const isDocImage = docSeleccionado ? isImage(docSeleccionado) : false;
  return (
    <div className={styles.documentSection}>
      <SectionTitle text={title} />

      <div className={styles.styleDivgeneral}>
        {isDocImage ? (
          <>
            <img className={styles.imagenMosttrar} src={docSeleccionado} alt="documento" />
            <Button
              type="button"
              onClick={() => downloadElement(docSeleccionado, 'png')}
              className={styles.buttonDownload}
              variant="secondary"
              text={I18n.t('download')}
            />
          </>
        ) : (
          <>
            <div className={styles.pdfViewer}>
              <object
                className={styles.imagenMosttrar}
                data={docSeleccionado === undefined ? `${docSeleccionado}#zoom=80` : `${docSeleccionado}#zoom=80`}
                type="application/pdf"
                aria-labelledby="pdf"
                width="100%"
                height="500"
              />
            </div>
            <Button
              type="button"
              onClick={() => downloadElement(docSeleccionado, 'pdf')}
              className={styles.buttonDownload}
              variant="secondary"
              text={I18n.t('download')}
            />
          </>
        )}
      </div>

      <div className={styles.test}>
        {documentos.map((doc, i) =>
          isImage(doc.documento) ? (
            <img
              key={doc.id}
              src={doc.documento}
              alt={doc.nombre}
              height={100}
              className={styles.imagenThumnail}
              onClick={() => onPreview(doc.documento, i)}
            />
          ) : (
            <button
              key={doc.id}
              className={styles.imagenThumnail}
              type="button"
              data-r={doc.documento}
              onClick={() => onPreview(doc.documento, i)}
            >
              {doc.nombre}
            </button>
          ),
        )}
      </div>
    </div>
  );
};
